import React, { FC } from 'react';
import { Grid } from '@mui/material';
import { usePerformance } from '../performance.context';
import { PerformanceReviewType } from '../performance.interfaces';
import PerformanceHeader from './PerformanceHeader';
import PerformanceFilters from './PerformanceFilters';
import PerformanceQuickStats from './PerformanceQuickStats';
import PerformanceViewSelector from './PerformanceViewSelector';

const PerformanceContent: FC = () => {
  const {
    state,
    setReviewType,
    setFilters,
    setSearchQuery,
    setSelectedReview,
    resetFilters,
    getFilteredReviews,
    getCurrentSummary,
    exportReviews,
  } = usePerformance();

  const handleReviewTypeChange = (type: PerformanceReviewType) => {
    setReviewType(type);
  };

  const handleFilterChange = (filterKey: string, value: any) => {
    setFilters({ [filterKey]: value });
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handleExport = async (format: 'pdf' | 'excel') => {
    await exportReviews(format);
  };

  const handleReviewSelect = (review: any) => {
    setSelectedReview(review);
    // TODO: Open review detail modal/drawer
    console.log('Selected review:', review);
  };

  const filteredReviews = getFilteredReviews();
  const currentSummary = getCurrentSummary();

  return (
    <Grid 
      container 
      id="performanceViewContainer" 
      sx={{ 
        height: '100%',
        px: { xs: 1, sm: 2 },
        py: { xs: 1, sm: 2 },
      }}
      data-testid="performance-content-container"
    >
      {/* Header Section */}
      <PerformanceHeader onExport={handleExport} />

      {/* Filter and Selection Section */}
      <PerformanceFilters
        onReviewTypeChange={handleReviewTypeChange}
        onFilterChange={handleFilterChange}
        onSearchChange={handleSearchChange}
        onResetFilters={resetFilters}
      />

      {/* Quick Stats */}
      <PerformanceQuickStats summary={currentSummary} />

      {/* Main Content Area */}
      <Grid item xs={12}>
        <PerformanceViewSelector
          reviewType={state.currentReviewType}
          filteredReviews={filteredReviews}
          currentSummary={currentSummary}
          onReviewSelect={handleReviewSelect}
        />
      </Grid>
    </Grid>
  );
};

export default PerformanceContent;
